import { ProgramSelectComponent } from './component/program-select/program-select.component';
import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpModule, RequestOptions} from '@angular/http';
import {AlertModule, BsDropdownModule, CollapseModule} from 'ngx-bootstrap';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app.routing.module';
import {HomePageComponent} from './component/home-page/home-page.component';
import {HeaderComponent} from './component/header/header.component';
import {LoginComponent} from './component/login/login.component';
import {AccountSummaryComponent} from './component/account-summary/account-summary.component';
import {RegistrationComponent} from './component/registration/registration.component';
import {CommonModule} from '@angular/common';
import {EmailValidationComponent} from './component/email-validation/email-validation.component';
import {CheckEmailComponent} from './component/check-email/check-email.component';
import {EmailSuccessComponent} from './component/email-success/email-success.component';
import {BillingAddressComponent} from './component/billing-address/billing-address.component';
import {CreditCardComponent} from './component/credit-card/credit-card.component';
import { CreditCardIframeComponent } from './component/credit-card-iframe/credit-card-iframe.component';
import {BillingCreditCardComponent} from './component/billing-credit-card/billing-credit-card.component';
import {CustomerSelectComponent} from './component/customer-select/customer-select.component';
import {EditCreditCardComponent} from './component/edit-credit-card/edit-credit-card.component';
import {AccountsCardPageComponent} from './component/accounts-card-page/accounts-card-page.component';
import {TollPassComponent} from './component/toll-pass/toll-pass.component';
import {CurrencyComponent} from './component/currency/currency.component';
import {AccountDetailComponent} from './component/account-detail/account-detail.component';
import {ChangeCurrencyComponent} from './component/change-currency/change-currency.component';
import {ConfirmPaymentComponent} from './component/confirm-payment/confirm-payment.component';
import {LoggedInAsComponent} from './component/logged-in-as/logged-in-as.component';
import {ReceiptComponent} from './component/receipt/receipt.component';
import {EditAccountCardsComponent} from './component/edit-account-cards/edit-account-cards.component';
import {AccountSelectComponent} from './component/account-select/account-select.component';
import {ConfirmationDialogComponent} from './component/confirmation-dialog/confirmation-dialog.component';
import {LoadingComponent} from './component/loading/loading.component';
import {ForgotPasswordComponent} from './component/forgot-password/forgot-password.component';
import {EditTollPassComponent} from './component/edit-toll-pass/edit-toll-pass.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatDialogModule, MatSlideToggleModule, MatTabsModule,
        MatTableModule, MatPaginatorModule, MatDatepickerModule,
        MatInputModule, MatNativeDateModule, MatSortModule,
        MatButtonModule, MatTooltipModule, MatExpansionModule
       } from '@angular/material';
import {AutoLoginComponent} from './component/auto-login/auto-login.component';
import {RenewalAmountComponent} from './component/renewal-amount/renewal-amount.component';
import {EditCreditCardsComponent} from './component/edit-credit-cards/edit-credit-cards.component';
import {AddCreditCardDialogComponent} from './component/add-credit-card-dialog/add-credit-card-dialog.component';
import {UpdateCreditCardDialogComponent} from './component/update-credit-card-dialog/update-credit-card-dialog.component';
import {UpdateMailingAddressComponent} from './component/update-mailing-address/update-mailing-address.component';
import {UpdateBillingAddressComponent} from './component/update-billing-address/update-billing-address.component';
import {ManageProfileComponent} from './component/manage-profile/manage-profile.component';
import {UpdateEmailComponent} from './component/update-email/update-email.component';
import {MailingAddressComponent} from './component/mailing-address/mailing-address.component';
import {MakePaymentComponent} from './component/make-payment/make-payment.component';
import {UpdatePasswordComponent} from './component/update-password/update-password.component';
import {ResultDialogComponent} from './component/result-dialog/result-dialog.component';
import {AddTollPassDialogComponent} from './component/add-toll-pass-dialog/add-toll-pass-dialog.component';
import {ShowCodeDialogComponent} from './component/show-code-dialog/show-code-dialog.component';
import {PaymentHistoryComponent} from './component/payment-history/payment-history.component';
import {CdkTableModule} from '@angular/cdk/table';
import {ReceiptDialogComponent} from './component/receipt-dialog/receipt-dialog.component';
import {UpdateForgottenPasswordComponent} from './component/update-forgotten-password/update-forgotten-password.component';
import {CustomerServiceComponent} from './component/customer-service/customer-service.component';
import {FrequentlyAskedQuestionsComponent} from './component/frequently-asked-questions/frequently-asked-questions.component';
import {ProgramDetailComponent} from './component/program-detail/program-detail.component';
import { LoadingSmComponent } from './component/loading-sm/loading-sm.component';
import { LowBalanceDialogComponent } from './component/low-balance-dialog/low-balance-dialog.component';
import { UserAgentDialogComponent } from './component/user-agent-dialog/user-agent-dialog.component'
import { EmailValidationResendComponent } from './component/email-validation-resend/email-validation-resend.component';

import { CoreModule } from '@core/core.module';
import { SharedModule } from '@shared/shared.module';
import { RefundDialogComponent } from './component/refund-dialog/refund-dialog.component';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';



@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,
    HeaderComponent,
    LoginComponent,
    AccountSummaryComponent,
    RegistrationComponent,
    EmailValidationComponent,
    CheckEmailComponent,
    EmailSuccessComponent,
    BillingAddressComponent,
    CreditCardComponent,
    CreditCardIframeComponent,
    BillingCreditCardComponent,
    CustomerSelectComponent,
    EditCreditCardComponent,
    AccountsCardPageComponent,
    TollPassComponent,
    CurrencyComponent,
    AccountDetailComponent,
    ChangeCurrencyComponent,
    ConfirmPaymentComponent,
    LoggedInAsComponent,
    ReceiptComponent,
    EditAccountCardsComponent,
    AccountSelectComponent,
    ConfirmationDialogComponent,
    LoadingComponent,
    ForgotPasswordComponent,
    EditTollPassComponent,
    AutoLoginComponent,
    RenewalAmountComponent,
    EditCreditCardsComponent,
    AddCreditCardDialogComponent,
    UpdateCreditCardDialogComponent,
    UpdateMailingAddressComponent,
    UpdateBillingAddressComponent,
    ManageProfileComponent,
    UpdateEmailComponent,
    MailingAddressComponent,
    MakePaymentComponent,
    UpdatePasswordComponent,
    ResultDialogComponent,
    AddTollPassDialogComponent,
    PaymentHistoryComponent,
    UpdateForgottenPasswordComponent,
    ReceiptDialogComponent,
    CustomerServiceComponent,
    FrequentlyAskedQuestionsComponent,
    ProgramDetailComponent,
    ShowCodeDialogComponent,
    LoadingSmComponent,
    LowBalanceDialogComponent,
    UserAgentDialogComponent,
    EmailValidationResendComponent,
    RefundDialogComponent,
    ProgramSelectComponent
  ],
  imports: [
    BrowserModule,
    CoreModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule,
    HttpModule,
    AlertModule.forRoot(),
    BsDropdownModule.forRoot(),
    AppRoutingModule,
    CommonModule,
    CollapseModule,
    MatDialogModule,
    MatTabsModule,
      MatSlideToggleModule,
      MatTableModule,
      MatPaginatorModule,
      MatDatepickerModule,
      MatInputModule,
      MatNativeDateModule,
      MatSortModule,
    MatButtonModule, MatTooltipModule,
    MatExpansionModule,
    SharedModule,
    RecaptchaV3Module
  ],
  entryComponents: [
    EditTollPassComponent,
    AddCreditCardDialogComponent,
    ConfirmationDialogComponent,
    UpdateCreditCardDialogComponent,
    ResultDialogComponent,
    AddTollPassDialogComponent,
    ReceiptDialogComponent,
    ShowCodeDialogComponent,
    LowBalanceDialogComponent,
    UserAgentDialogComponent,
    RefundDialogComponent
  ],
  providers: [{ provide: RECAPTCHA_V3_SITE_KEY, useValue: '6LfMR5EqAAAAAMIiicl3a5aulfK00w5W6kq6nBlG' },],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/app.module.ts